// Taşeron portalı — Supplier İş İzni (api-contract §21) TanStack Query anahtarları.
//
// Yetkili **yalnız kendi** contractor'ının izinlerini görür (firma/contractor kimliği
// token/bağdan çözülür — istemci göndermez). Anahtarlar contractor uuid TAŞIMAZ; aktif firma
// (`companyId`) değişince (switcher → `/auth/switch-company`) sorgular yeniden çekilir —
// companyId anahtara katılır ki firma değişiminde önbellek karışmasın (supplierContractorKeys
// deseniyle aynı).

import type { SupplierPermitListParams } from '@isgportal/shared';

export const supplierPermitKeys = {
  /** Tüm supplier izin sorgularının kök öneki. */
  all: () => ['supplier-permits'] as const,
  /** Liste kökü (invalidate hedefi — parametreden bağımsız). */
  list: (companyId: number | null) => ['supplier-permits', 'list', companyId] as const,
  /** Parametreli liste (filtre/sayfa) — placeholderData ile sayfa geçişinde stabil. */
  listParams: (companyId: number | null, params: SupplierPermitListParams) =>
    ['supplier-permits', 'list', companyId, params] as const,
  /** Tek izin detayı (izin + gerekli eğitim + personel readiness). */
  detail: (companyId: number | null, uuid: string) =>
    ['supplier-permits', 'detail', companyId, uuid] as const,
} as const;
